import PartnerRegistrationForm from '@/components/Forms/PartnerRegistration/PartnerRegistrationForm.tsx';
import { PartnerRegistrationFormType } from '@/components/Forms/PartnerRegistration/usePartnerRegistrationForm.ts';
import usePartnerRegistrationModal from '@/components/Forms/PartnerRegistration/usePartnerRegistrationModal.ts';
import ThemeButton from '@/theme/Components/ThemeButton/ThemeButton.tsx';
import { Modal } from 'antd';
import { ReactNode } from 'react';

interface PartnerRegistrationModalProps {
  /** Libellé (déjà traduit) du bouton qui ouvre la modale. */
  triggerLabel: ReactNode;
  /** Titre (déjà traduit) de la modale. Par défaut, reprend le libellé du bouton. */
  title?: ReactNode;
  onSubmit?: (values: PartnerRegistrationFormType) => void;
  loading?: boolean;
  initialValues?: Partial<PartnerRegistrationFormType>;
  referralOptions?: { value: string; label: string }[];
  cguUrl?: string;
  /** `Partners - Orias facultatif` — true: ORIAS facultatif & SIREN requis ; false: ORIAS requis. */
  oriasOptional?: boolean;
  /** `Code partenaire à l'inscription réseau` — affiche le champ "code partenaire". */
  showPartnerCode?: boolean;
  /** Clé publique Cloudflare Turnstile ; vide => aucun captcha. */
  turnstileSiteKey?: string;
  /** Langue du widget Turnstile (langue courante de la page). */
  language?: string;
  /** Incrémenté par l'appelant pour réinitialiser le captcha après un échec de soumission. */
  captchaResetKey?: number;
}

const PartnerRegistrationModal = ({
  triggerLabel,
  title,
  onSubmit,
  loading,
  initialValues,
  referralOptions,
  cguUrl,
  oriasOptional,
  showPartnerCode,
  turnstileSiteKey,
  language,
  captchaResetKey,
}: PartnerRegistrationModalProps) => {
  const { open, openModal, closeModal, handleSubmit } =
    usePartnerRegistrationModal({ onSubmit });

  return (
    <>
      <div style={{ width: '100%' }}>
        <ThemeButton block onClick={openModal} variant="outlined">
          {triggerLabel}
        </ThemeButton>
      </div>

      <Modal
        destroyOnHidden
        footer={null}
        onCancel={closeModal}
        open={open}
        title={title ?? triggerLabel}
        width={600}
      >
        <PartnerRegistrationForm
          captchaResetKey={captchaResetKey}
          cguUrl={cguUrl}
          initialValues={initialValues}
          language={language}
          loading={loading}
          onLoginClick={closeModal}
          onSubmit={handleSubmit}
          oriasOptional={oriasOptional}
          referralOptions={referralOptions}
          showPartnerCode={showPartnerCode}
          turnstileSiteKey={turnstileSiteKey}
        />
      </Modal>
    </>
  );
};

export default PartnerRegistrationModal;
